import { cn } from '@simplywallst/ui-core/next';
import { useEffect, useState } from 'react';

// Sydney timezone 29th April 2025, 10:00am
export const END_DATE = new Date(1745884800000);

export const calculateTimeRemaining = () => END_DATE.getTime() - Date.now();

export const getTimeLabelAndUrgency = (
  time: number
): { label: string; urgency: 'medium' | 'high' | 'ended' } => {
  if (time <= 0) {
    return { label: 'Ended', urgency: 'ended' };
  }

  const days = Math.floor(time / (1000 * 60 * 60 * 24));
  const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((time / (1000 * 60)) % 60);
  const seconds = Math.floor(time / 1000) % 60;

  const urgency = days <= 2 ? 'high' : 'medium';

  if (urgency === 'medium') {
    return { label: `Ends in ${days} days`, urgency };
  }

  const secondsString = String(seconds).padStart(2, '0');
  return {
    label: `${days}d ${hours}h ${minutes}m ${secondsString}s`,
    urgency,
  };
};

export const CountdownTimer = () => {
  const [timeRemaining, setTimeRemaining] = useState(calculateTimeRemaining);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeRemaining(calculateTimeRemaining());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const { label, urgency } = getTimeLabelAndUrgency(timeRemaining);

  return (
    <div
      className={cn(
        'rounded-full px-3 py-0.5 text-center text-[12px] max-[320px]:hidden md:text-[13px]',
        urgency === 'medium' && 'bg-warning text-p-white-100',
        ['high', 'ended'].includes(urgency) && 'bg-bad text-p-white-100'
      )}
    >
      {['medium', 'ended'].includes(urgency) ? (
        label
      ) : (
        <>
          Ends in<span className="font-mono">&nbsp;{label}</span>
        </>
      )}
    </div>
  );
};
